import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  AppBar,
  Tabs,
  TextField,
  Tab,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  FormControl,
  FormHelperText
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

import Button from '../Button';
import TabPanel from '../../components/TabPanel';

import { isEmailAvailable } from '../../services/api';
import { faxPattern, formatFax } from '../../util/formatFax';

function AdministratorEditModal(props) {
  const {
    open,
    administrator,
    onClose,
    save,
    classes: { modal, modalContent, actions, input },
  } = props;
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [validationErrors, setValidationErrors] = useState({});
  // const [emailAvailable, setAvailable] = useState(false);
  const [adminstratorUserId] = useState(administrator?.userId || null);
  const [optStatus, setOptStatus] = useState(
    administrator?.sendMail !== undefined ? administrator.sendMail : true
  );
  const [notificationPreference, setNotificationPreference] = useState(
    administrator?.notificationPreference || 'email'
  );
  const [fax, setFax] = useState(administrator?.fax || '');

  useEffect(() => {
    setFirstName(administrator.firstName);
    setLastName(administrator.lastName);
    setEmail(administrator.email);
  }, []);

  const validate = async () => {
    let valid = true;
    const nextState = {};
    if (!firstName || !firstName.replace(/^\s+|\s+$/gm, '')) {
      valid = false;
      nextState.firstName = true;
    }
    if (!lastName || !lastName.replace(/^\s+|\s+$/gm, '')) {
      valid = false;
      nextState.lastName = true;
    }
    const trimmedEmail = email?.trim().toLowerCase();
    if (!trimmedEmail) {
      valid = false;
      nextState.email = true;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
      valid = false;
      nextState.email = 'Invalid email format';
    }
    // else if (
    //   trimmedEmail.includes('@example') ||
    //   trimmedEmail.includes('@test') ||
    //   trimmedEmail.includes('@demo') ||
    //   trimmedEmail.includes('@testing')
    // ) {
    //   valid = false;
    //   nextState.email = 'This email domain is not allowed';
    // } 
    else if (trimmedEmail) {
      const available = await isEmailAvailable(trimmedEmail, adminstratorUserId);
      if (!available) {
        valid = false;
        nextState.email = 'This email is already in use';
      }
    }
    if (notificationPreference !== 'email' || (fax && fax.trim().length > 0)) {
       if (!fax) {
            valid = false;
            nextState.fax = 'Fax number is required';
          } else if (!faxPattern.test(fax)) {
            valid = false;
            nextState.fax = 'Enter a valid 10 digit fax number';
          }
    }
    setValidationErrors(nextState);
    return valid;
  };

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    if (open) {
      html.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
    } else {
      html.style.overflow = '';
      body.style.overflow = '';
    }

    return () => {
      html.style.overflow = '';
      body.style.overflow = '';
    };
  }, [open]);

  return (
    <Dialog fullWidth open={open} onClose={onClose} classes={{ paper: modal }}>
      <DialogTitle>
        <Grid container alignItems="center">
          <Grid item xs={11}>
            <h2>{administrator.name || 'New Administrator'}</h2>
          </Grid>

          <Grid item xs={1}>
            <IconButton aria-label="Close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent classes={{ root: modalContent }}>
        <AppBar position="static" color="default">
          <Tabs value={0}>
            <Tab label="Profile" />
          </Tabs>
        </AppBar>

        <TabPanel>
          <TextField
            fullWidth
            variant="outlined"
            label="First Name"
            name="firstName"
            value={firstName}
            error={validationErrors.firstName}
            helperText={validationErrors.firstName ? 'Required' : null}
            onChange={event => {
              setFirstName(event.target.value);
              setValidationErrors({
                ...validationErrors,
                [event.target.name]: false,
              });
            }}
            className={input}
          />

          <TextField
            fullWidth
            variant="outlined"
            label="Last Name"
            name="lastName"
            value={lastName}
            error={validationErrors.lastName}
            helperText={validationErrors.lastName ? 'Required' : null}
            onChange={event => {
              setLastName(event.target.value);
              setValidationErrors({
                ...validationErrors,
                [event.target.name]: false,
              });
            }}
            className={input}
          />

          <TextField
            fullWidth
            variant="outlined"
            label="Email"
            name="email"
            value={email}
            onChange={event => {
              const cleanEmail = event.target.value.trim().toLowerCase();
              setEmail(cleanEmail);
              setValidationErrors({
                ...validationErrors,
                [event.target.name]: false,
              });
            }}
            error={validationErrors.email}
            helperText={validationErrors.email}
            className={input}
            inputProps={{
              onBlur: async () => {
                // if (
                //   email?.trim().toLowerCase().includes('@example') ||
                //   email?.trim().toLowerCase().includes('@test') ||
                //   email?.trim().toLowerCase().includes('@demo') ||
                //   email?.trim().toLowerCase().includes('@testing')
                // ) {
                //   setValidationErrors({
                //     ...validationErrors,
                //     email: 'This email domain is not allowed',
                //   });
                //   return;
                // }
                // const available = await isEmailAvailable(email?.trim().toLowerCase(), adminstratorUserId);
                // if (!available) {
                //   setValidationErrors({
                //     ...validationErrors,
                //     email: 'This email is already in use',
                //   });
                //   return;
                // }
              },
            }}
          />
          <FormControl component="fieldset" className={input}>
          <FormLabel component="legend">Notification Preference</FormLabel>
          <RadioGroup
            row
            name="notificationPreference"
            value={notificationPreference}
            onChange={e => setNotificationPreference(e.target.value)}
          >
             <FormControlLabel value="both" control={<Radio />} label="Both" />
             <FormControlLabel value="email" control={<Radio />} label="Email" />
             <FormControlLabel value="fax" control={<Radio />} label="Fax" />
          </RadioGroup>
          <FormHelperText>
            {notificationPreference === "email" && "Administrator will receive notifications by email only."}
            {notificationPreference === "both" && "Administrator will receive notifications by both email and fax."}
            {notificationPreference === "fax" && "Administrator will receive notifications by fax only. Fax number below required."}
          </FormHelperText>
        </FormControl>

        <TextField
          fullWidth
          variant="outlined"
          label="Fax"
          name="fax"
          value={fax ? `+1 ${formatFax(fax)}` : "+1 "}
          onChange={(event) => {
            const input = event.target.value;
            // Extract digits and remove country code if present
            const digits = input.replace(/\D/g, "");
            const withoutCountry = digits.startsWith("1") ? digits.slice(1) : digits;
            const limitedDigits = withoutCountry.slice(0, 10); // ensure max 10 digits

            setFax(limitedDigits);

            // Inline validation
            if (limitedDigits.length > 0 && limitedDigits.length < 10) {
              setValidationErrors({
                ...validationErrors,
                fax: "Fax must be 10 digits",
              });
            } else {
              setValidationErrors({
                ...validationErrors,
                fax: false,
              });
            }
          }}
          error={!!validationErrors.fax}
          helperText={
            validationErrors.fax ||
            "Provide a 10-digit fax number. All faxes will be sent via Metrofax."
          }
        />
        {
            administrator.name &&
            <FormControl component="fieldset" className={input}>
              <FormLabel component="legend">Send Mail</FormLabel>
              <RadioGroup
                row
                aria-label="opt-status"
                name="optStatus"
                value={optStatus.toString()}
                onChange={(event) => setOptStatus(event.target.value === 'true')}
              >
                <FormControlLabel value="true" control={<Radio />} label="Opt-in" />
                <FormControlLabel value="false" control={<Radio />} label="Opt-out" />
              </RadioGroup>
            </FormControl>
          }

          <Grid container justifyContent="flex-end" classes={{ container: actions }}>
            <Grid item xs={12} lg={6}>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                onClick={() =>
                  save({
                    id: administrator.id,
                    email: email.trim(),
                    firstName: firstName.replace(/^\s+|\s+$/gm, ''),
                    lastName: lastName.replace(/^\s+|\s+$/gm, ''),
                    sendMail: optStatus,
                    fax: fax,
                    notificationPreference: notificationPreference
                  })
                }
                onClickValidation={validate}
              >
                Save Administrator
              </Button>
            </Grid>
          </Grid>
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
}

const styles = () => ({
  modal: {
    maxHeight: '700px',
  },
  modalContent: {
    overflow: 'visible',
  },
  actions: {
    marginTop: '1em',
  },
  input: {
    margin: '0.5em 0',
  },
});

AdministratorEditModal.propTypes = {
  open: PropTypes.bool.isRequired,
  administrator: PropTypes.object,
  save: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles)(AdministratorEditModal);
